// extracted by mini-css-extract-plugin
export var header = "_bd-0";